var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFAD9E"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6262"
    },
    d: "M408.245,179.465L110.761,329.519l180.107,180.107C407.319,493.764,498.866,399.61,510.7,281.924 L408.245,179.465z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.417,
    y: 325.439,
    style: {
      fill: "#273B7A"
    },
    width: 24.533,
    height: 122.656
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B20040"
    },
    d: "M307.021,329.519h-196.26v-98.13c0-40.646,32.951-73.597,73.597-73.597h171.727"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#940030"
    },
    points: "356.087,157.793 241.635,157.793 241.635,329.519 307.021,329.519 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#273B7A"
    },
    d: "M429.684,231.39c0-40.646-32.951-73.597-73.597-73.597s-73.597,32.951-73.597,73.597v98.13h147.196 v-98.13H429.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03A00"
    },
    d: "M233.424,214.614c-4.284,0-7.758-3.474-7.758-7.758v-90.372h-41.308 c-4.284,0-7.758-3.474-7.758-7.758s3.474-7.758,7.758-7.758h49.066c4.284,0,7.758,3.474,7.758,7.758v98.13 C241.181,211.142,237.709,214.614,233.424,214.614z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.029,
    y: 220.47,
    style: {
      fill: "#FFC61B"
    },
    width: 118.105,
    height: 78.739
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFEDB5"
    },
    points: "415.141,220.472 356.087,259.843 297.031,220.472 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.9f93a6d75c6d70a387629b67a3e3424a.svg";
export { ForwardRef as ReactComponent };